import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Current Loan to Value (LTV) ratio' },
  description: {
    defaultMessage:
      'Current LTV is your total borrowed value divided by your total collateral value. It shows your current debt ratio and is separate from Maximum LTV and the liquidation threshold.',
  },
});
